import { FC, useState, createContext, useContext, SetStateAction } from 'react';
import { SearchModel } from 'src/models/chat';
type SearchContext = {
  value: string;
  setValue: React.Dispatch<SetStateAction<string>>;
  searchList: SearchModel[];
  setSearchList: React.Dispatch<SetStateAction<SearchModel[]>>;
  searchType: 'local' | 'global';
  setSearchType: React.Dispatch<SetStateAction<'local' | 'global'>>;
};

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SearchContext = createContext<SearchContext>({} as SearchContext);

export const SearchProvider: FC = ({ children }) => {
  const [value, setValue] = useState('');
  const [searchList, setSearchList] = useState<SearchModel[]>([]);
  const [searchType, setSearchType] = useState<'local' | 'global'>('global');

  return (
    <SearchContext.Provider
      value={{
        value,
        setValue,
        searchList,
        setSearchList,
        searchType,
        setSearchType
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  return useContext(SearchContext);
};
